export * from './src/portfolio-collections-v1-collection-collections.universal.js';
